import Vue from 'vue'
import Router from 'vue-router'
import Login from '../components/login/index_pc.vue'
import Code from '../components/login/weixinLogin/code/code'
import Register from '../components/login/register_pc'


import Index from '../components/index'
import Live from '../components/live'
import Testlist from '../components/live/testlivelist'
import Clear from '../components/clear'
import Video from '../components/video'
import Allvideo from '../components/video/alllist'
import AllLives from '../components/live/alllives'
import Me from '../components/me'
import Column from '../components/column'
import colDetails from '../components/column/colDetails'
import EditInfo from '../components/me/editingInfo'
import End from '../components/me/end'
import Collection from '../components/me/collection'
import Userinfo from '../components/me/center'
import ShareQRCode from '../components/me/ShareQRCode/ShareQRCode'
import SubscribeQRCode from '../components/me/SubscribeQRCode/SubscribeQRCode'
import Vip from '../components/me/vip'
import Bespoke from '../components/me/bespoke'
import Details from '../components/container/details'
import activeInfo from '../components/container/activeInfo'
import Activity from '../components/Activity/inedx'
import vDetails from '../components/container/vDetails'
import AppSetting from './../AppSetting'

Vue.use(Router)

const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

const router= new Router({
  mode: "history",
  // TODO 正则上线时要把下面注释去了
  base: `/${AppSetting.RouterBase}/`,
  routes: [{
      path: "/",
      redirect: "/index/live"
    },
    {
      path: '/clear',
      name: 'Clear',
      component: Clear
    }, {
      path: '/login',
      name: 'Login',
      component: Login
    }, {
      path: '/weixinLogin/code',
      name: 'Code',
      component: Code
    }, {
      path: '/register',
      name: 'Register',
      component: Register
    }, {
      path: '/activeinfo',
      name: 'activeInfo',
      component: activeInfo
    }, {
      path: '/userinfo',
      name: 'userinfo',
      component: Userinfo
    }, {
      path: '/ShareQRCode',
      name: 'ShareQRCode',
      component: ShareQRCode
    }, {
      path: '/SubscribeQRCode',
      name: 'SubscribeQRCode',
      component: SubscribeQRCode
    },{
      path: '/activity',
      name: 'Activity',
      component: Activity
    }, {
      path: '/details',
      name: 'Details',
      component: Details,
    }, {
      path: '/coldetails',
      name: 'colDetails',
      component: colDetails,
    }, {
      path: '/editInfo',
      name: 'EditInfo',
      component: EditInfo,
    }, {
      path: '/end',
      name: 'End',
      component: End,
    }, {
      path: '/bespoke',
      name: 'Bespoke',
      component: Bespoke,
    }, {
      path: '/collection',
      name: 'Collection',
      component: Collection,
    }, {
      path: '/index/allvideo',
      name: 'Allvideo',
      component: Allvideo,
    }, {
      path: '/index/alllives',
      name: 'AllLives',
      component: AllLives,
    }, {
      path: '/testlivelist',
      name: 'Testlist',
      component: Testlist
    }, {
      path: '/vdetails',
      name: 'vDetails',
      component: vDetails,
    }, {
      path: '/index',
      name: 'Index',
      component: Index,
      children: [{
          path: "/index",
          redirect: "/index/live"
        },

        {
          path: '/index/live',
          name: 'Live',
          component: Live
        }, {
          path: '/index/video',
          name: 'Video',
          component: Video,
          meta: {
            keepAlive: true,
            keepAliveChange: true
          }
        }, {
          path: '/index/me',
          name: 'Me',
          component: Me
        }, {
          path: '/index/vip',
          name: 'Vip',
          component: Vip
        }, {
          path: '/index/column',
          name: 'Column',
          component: Column
        },
      ]
    }
  ]
})

import httpGard from './gard/httpGard'
import SSOGard from './gard/SSOGard'
import ShareKeyGard from './gard/ShareKeyGard'
import SubscribeGard from './gard/SubscribeGard'
import KeepAliveGard from './gard/KeepAliveGard'
import UserInfoGard from './gard/UserInfoGard'

router.beforeEach(httpGard)
// 自动登录
router.beforeEach(ShareKeyGard)
// 获取用户信息，单点登录
router.beforeEach(SSOGard)
// 验证手机号是否填写
router.beforeEach(UserInfoGard)
// 必须关注公众号
router.beforeEach(SubscribeGard)
// 保持状态
router.beforeEach(KeepAliveGard)

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js